import React from 'react';
import NewId from '../../utils/NewId';

export default class Button extends React.Component {
    constructor(props) {
        super(props);

        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);

        const date = new Date();

        this.state = {
            month: props.month || ( date.getMonth() + 1 ),
            year: props.year || ( date.getYear() + 1900 ) //in js the first year is 1900
        };

        this.monthNames = {
            1: "Януари",
            2: "Февруари",
            3: "Март",
            4: "Април",
            5: "Май",
            6: "Юни",
            7: "Юли",
            8: "Август",
            9: "Септември",
            10: "Октомври",
            11: "Ноември",
            12: "Декември"
        }
    }

    prev() {
        let month = this.state.month - 1;
        let year = this.state.year;
        if (month <= 0) {
            month = 12;
            year--;
        }

        this.setState({month, year})
    }

    next() {
        let month = this.state.month + 1;
        let year = this.state.year;
        if (month > 12) {
            month = 1;
            year++;
        }

        this.setState({month, year})
    }

    buildCalendarRows() {

        const {month, year} = this.state;
        const {highlights} = this.props;

        let date = new Date(year, month, 0);
        let firstOfMonthDate = new Date(date.getFullYear(), date.getMonth(), 1);
        const daysInMonth = date.getDate();
        let startDay = firstOfMonthDate.getDay() || 7; //normally Sunday is 0, but its easier to work with if it is 7
        let currentDay = 0;

        let rows = [];
        while (currentDay < daysInMonth) {
            let row = [];
            let rowId = NewId('calendar-week');
            for (let i = 0; i < 7; i++) {
                if (i < startDay - 1 || currentDay > daysInMonth) {
                    row.push(<td key={NewId(`${rowId}`)} className="no-bg"></td>);
                }
                else if (currentDay < daysInMonth) {
                    currentDay++;
                    let dayString = currentDay.toString().padStart(2, "0");
                    let monthString = month.toString().padStart(2, "0");
                    let currentDayString = `${year}-${monthString}-${dayString}`;
                    let className = null;
                    if (highlights.indexOf(currentDayString) !== -1) className = "meditation";

                    row.push(<td key={NewId(`${rowId}`)} className={className}>{currentDay}</td>);
                }
            }
            startDay = 0;
            rows.push(<tr key={rowId}>{row}</tr>);
        }

        return rows;
    }

    render() {
        let calendarRows = this.buildCalendarRows();
        const {month, year} = this.state;

        return <div className={this.props.className}>
            <table>
                <thead>
                <tr>
                    <th colSpan="7">
                        <div className="calendar-navigation">
                            <button onClick={this.prev} className="arrow arrow-left" />
                            <div className="calendar-title">
                                <h3>{year},</h3>
                                <h4>{this.monthNames[month]}</h4>
                            </div>
                            <button onClick={this.next} className="arrow arrow-right" />
                        </div>
                    </th>
                </tr>
                <tr>
                    <th>Пн</th>
                    <th>Вт</th>
                    <th>Ср</th>
                    <th>Чт</th>
                    <th>Пт</th>
                    <th>Сб</th>
                    <th>Нд</th>
                </tr>
                </thead>
                <tbody>
                {calendarRows}
                </tbody>
            </table>
            <div className="calendar-header">
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Calendar.js